module.exports = __webpack_public_path__ + "static/media/eduPurple.1b402da2.svg";